import { render, staticRenderFns } from "./UpdateCheckBoardDialog.vue?vue&type=template&id=5209925a&scoped=true"
import script from "./UpdateCheckBoardDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCheckBoardDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCheckBoardDialog.vue?vue&type=style&index=0&id=5209925a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5209925a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5209925a')) {
      api.createRecord('5209925a', component.options)
    } else {
      api.reload('5209925a', component.options)
    }
    module.hot.accept("./UpdateCheckBoardDialog.vue?vue&type=template&id=5209925a&scoped=true", function () {
      api.rerender('5209925a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UpdateCheckBoardDialog.vue"
export default component.exports